import { jsx as v } from "react/jsx-runtime";
import { BaseDatePicker as x } from "./base-date-picker.js";
const j = ({
  localeString: e,
  canSelectPastDates: a,
  dots: t,
  isExpanded: o,
  markSundayRed: r,
  onMonthChange: i,
  weekNumbers: n,
  showDaysOutsideMonth: s,
  selectedMonth: c,
  onDateChange: f,
  selectedDate: g,
  shouldDisableDate: m,
  strikeThroughDates: d,
  isDisabled: k,
  redDays: l,
  disablePastMonths: p,
  disableBackwardNavigation: D,
  disableForwardNavigation: R
}) => /* @__PURE__ */ v(
  x,
  {
    localeString: e,
    canSelectPastDates: a,
    dots: t,
    isExpanded: o,
    markSundayRed: r,
    onMonthChange: i,
    weekNumbers: n,
    showDaysOutsideMonth: s,
    selectedMonth: c,
    onDateChange: f,
    selectedDate: g,
    shouldDisableDate: m,
    strikeThroughDates: d,
    redDays: l,
    isRangeDate: !1,
    selectWeek: !1,
    isDisabled: k,
    dateRange: void 0,
    onRangeChange: void 0,
    disablePastMonths: p,
    disableBackwardNavigation: D,
    disableForwardNavigation: R
  }
);
export {
  j as DatePicker
};
